import styled from "styled-components";

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background-color: #f0f2f5;

  & .logo-container {
    display: flex;
    justify-content: center;
    padding-bottom: 32px;
  }

  & .error-container {
    display: flex;
    justify-content: center;
    padding-bottom: 16px;
  }
`;

export const Form = styled.form`
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 300px;
  display: flex;
  flex-direction: column;
`;
